/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Report_WordInputs */

const en_why_listening_report_word = /** @type {(inputs: Why_Listening_Report_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report a word`)
};

const es_why_listening_report_word = /** @type {(inputs: Why_Listening_Report_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reportar una palabra`)
};

/**
* | output |
* | --- |
* | "Report a word" |
*
* @param {Why_Listening_Report_WordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_report_word = /** @type {((inputs?: Why_Listening_Report_WordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Report_WordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_report_word(inputs)
	return en_why_listening_report_word(inputs)
});